import React, { useContext, useEffect, useState } from "react";
import Applayout from "./layout/applayout";
import Modal from "../components/app/modal";
import { Link } from "react-router-dom";
import Loader from "../components/app/loader";
import axiosClient from "../axios/axiosClient";
import { toast } from "react-toastify";
import AuthContext from "../context/AuthContext";
import Pagination from "../components/app/pagination";
import Swal from "sweetalert2";

function Beneficiaries() {

    const [modalTitle, setModalTitle] = useState("Edit Profile");
    const [editCaseId, setEditCaseId] = useState("");
    const [pagination, setPagination] = useState({});
    const [formData, setFormData] = useState({
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      date_of_birth: '',
      gender: '',
      photo: null
    });

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    };
  
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      const { name } = e.target;
      if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
              // Set the base64 string as part of the form data
              setFormData({ ...formData, [name]: reader.result });
          };
          reader.readAsDataURL(file);  // Convert to Base64
      }
    };
    const [loading, setLoading] = useState(false);
    const [beneficiaries, setBeneficiaries] = useState([]);
  
    const [isEditing, setIsEditing] = useState(false);

    const handleEditSave = (e) => {
      e.preventDefault();
      setIsEditing(true);
      
      // Create a copy of formData excluding photo and profile_upload
      const dataToSend = { ...formData };
      
      // Only include photo if it's newly selected
      if (!formData.photo || (typeof formData.photo === 'string' && !formData.photo.startsWith('data:'))) {
          delete dataToSend.photo;
      }
      
      // Only include profile_upload if it's newly selected
      if (!formData.profile_upload || (typeof formData.profile_upload === 'string' && !formData.profile_upload.startsWith('data:'))) {
          delete dataToSend.profile_upload;
      }

      axiosClient.put(`/beneficiaries/${editCaseId}`, dataToSend)
          .then((response) => {
              resetFormData();
              getBeneficiaries();
              setIsEditing(false);
              toast.success('Beneficiary updated successfully');
          })
          .catch((error) => {
              setIsEditing(false);
              toast.error(error.response?.data?.message || 'Error updating beneficiary');
          });
    };

    const resetFormData = () => {
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        date_of_birth: '',
        gender: '',
        photo: null
      })
    }

    const setEditBeneficiary = (data) =>{
      setFormData(data)
    }

    const handleSubmit = (e) => {

        e.preventDefault();
        // Logic for form submission goes here
        axiosClient.post('/beneficiaries', formData)
        .then((response) => {
            resetFormData();
            getBeneficiaries();
            setLoading(false)
            toast.success('Beneficiary submitted successfully');

          })
          .catch((error) => {
            setLoading(false)
            toast.error(error.response.data.message);
        });
    };
    const { user } = useContext(AuthContext);

    const getBeneficiaries = (url='/beneficiaries') => {
      axiosClient.get(url)
            .then((response) => {
                setBeneficiaries(response.data.data.data);
                setPagination(response.data.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
                toast.error('Login failed. Please check your credentials.');
            });
    }

    const handlePageChange = (url) => {
      getBeneficiaries(url);
    };

    useEffect(() => {
        setLoading(true)
        getBeneficiaries()

    }, []);

    const handleDelete = (id, casesCount) => {
        // First check if beneficiary has cases
        if (casesCount > 0) {
            Swal.fire({
                title: 'Cannot Delete',
                text: 'This beneficiary has active cases. Please delete all associated cases first.',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });
            return;
        }

        // If no cases, proceed with delete confirmation
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axiosClient.delete(`/beneficiaries/${id}`)
                    .then((response) => {
                        getBeneficiaries();
                        setLoading(false);
                        toast.success('Beneficiary deleted successfully');
                    })
                    .catch((error) => {
                        setLoading(false);
                        const errorMessage = error.response?.data?.message || 'Error deleting beneficiary';
                        toast.error(errorMessage);
                        
                        // Show a more detailed error in SweetAlert
                        Swal.fire({
                            title: 'Delete Failed',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        });
                    });
            }
        });
    };

    const maskPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';
        
        // Keep first 2 digits and last 4 digits visible
        const firstTwo = phoneNumber.slice(0, 2);
        const lastFour = phoneNumber.slice(-4);
        const maskedPart = '*'.repeat(phoneNumber.length - 6);
        
        return `${firstTwo}${maskedPart}${lastFour}`;
    };

  return (
    <Applayout>
         <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>Beneficiaries</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">
                      <i data-feather="home"></i>
                    </a>
                  </li>
                  <li className="breadcrumb-item">Beneficiaries</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">
            Beneficiaries
            <div className="pull-right">
            <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                onClick={() => {resetFormData(); setModalTitle("Create Beneficiary")}} // Set modal title dynamically
            >
                Create
            </button>
          </div>
            </h4>
         
          <div className="card-options">
            <a
              className="card-options-collapse"
              href="edit-profile.html#"
              data-toggle="card-collapse"
            >
              <i className="fe fe-chevron-up"></i>
            </a>
            <a
              className="card-options-remove"
              href="edit-profile.html#"
              data-toggle="card-remove"
            >
              <i className="fe fe-x"></i>
            </a>
          </div>
        </div>
        { !loading ? (<div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th>Photo</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>email</th>
                <th>Phone</th>
                <th>Gender</th>
                <th>Cases</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                { beneficiaries.map((beneficiary, index) => {
                    // Calculate the correct index based on current page
                    const currentPage = pagination.current_page;
                    const perPage = pagination.per_page;
                    const correctIndex = (currentPage - 1) * perPage + index + 1;

                    return (
                        <tr key={beneficiary.id}>
                            <td>{correctIndex}</td>
                            <td><Link to={`/view-beneficiary/${beneficiary.id}`}><img className="w-50 rounded-circle" style={{height:"50px"}} src={beneficiary.photo? beneficiary.photo:'../assets/images/avtar/user.jpeg'} alt="Photo" /></Link></td>
                            <td>{beneficiary.first_name}</td>
                            <td>{beneficiary.last_name}</td>
                            <td>{beneficiary.email}</td>
                            <td>{maskPhoneNumber(beneficiary.phone_number)}</td>
                            <td>{beneficiary.gender}</td>
                            <td>{beneficiary.beneficiary_cases.length}</td>
                            <td>
                                <a class="btn btn-primary btn-sm me-2" href="javascript:void(0)" data-bs-original-title="" title="Edit" data-bs-toggle="modal"data-bs-target="#editMyModal" onClick={() => {setModalTitle("Edit Beneficiary"); setEditCaseId(beneficiary.id); setEditBeneficiary(beneficiary)}}><i class="fa fa-pencil"></i> </a>
                                <Link class="btn btn-success btn-sm" to={`/beneficiary-case/${beneficiary.id}`} data-bs-original-title="" title="Manage Cases"><i class="fa fa-file"></i> Cases</Link>
                                <button 
                                    className="btn btn-danger btn-sm ms-2" 
                                    title="Delete"
                                    onClick={() => handleDelete(beneficiary.id, beneficiary.beneficiary_cases.length)}
                                >
                                    <i className="fa fa-trash"></i> 
                                </button>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
          </table>
          <Pagination paginationData={pagination} onPageChange={handlePageChange} />
        </div>): <Loader />}
      </div>

      <Modal title={modalTitle} onSave={handleSubmit} modalId="myModal" modalSize="lg" modalPosition="centered">
        <div className="row g-3">
                <div className="col-md-6">
                    <label className="form-label" htmlFor="first_name">First Name</label>
                    <input
                        className="form-control"
                        id="first_name"
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="last_name">Last Name</label>
                    <input
                        className="form-control"
                        id="last_name"
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="email">Email</label>
                    <input
                        className="form-control"
                        id="email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="phone_number">Phone Number</label>
                    <input
                        className="form-control"
                        id="phone_number"
                        type="text"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="date_of_birth">Date of Birth</label>
                    <input
                        className="form-control"
                        id="date_of_birth"
                        type="date"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label">Gender</label>
                    <select
                        className="form-control"
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>

                <div className="col-md-6">
                <label className="form-label" htmlFor="photo">Photo</label>
                <input
                    className="form-control"
                    id="photo"
                    type="file"
                    name="photo"
                    accept="image/*"
                    onChange={handleFileChange}
                />
            </div>

            <div className="col-md-6">
                <label className="form-label" htmlFor="profile">Profile Document</label>
                <input
                    className="form-control"
                    id="profile"
                    type="file"
                    name="profile_upload"
                    accept="image/*,application/pdf"
                    onChange={handleFileChange}
                />
            </div>
        </div>
      </Modal>

      <Modal title={modalTitle} onSave={handleEditSave} modalId="editMyModal" modalSize="lg" modalPosition="centered">
          {isEditing ? (
              <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Updating beneficiary...</p>
              </div>
          ) : (
              <div className="row g-3">
                <div className="col-md-6">
                    <label className="form-label" htmlFor="first_name">First Name</label>
                    <input
                        className="form-control"
                        id="first_name"
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="last_name">Last Name</label>
                    <input
                        className="form-control"
                        id="last_name"
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="email">Email</label>
                    <input
                        className="form-control"
                        id="email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="phone_number">Phone Number</label>
                    <input
                        className="form-control"
                        id="phone_number"
                        type="text"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="date_of_birth">Date of Birth</label>
                    <input
                        className="form-control"
                        id="date_of_birth"
                        type="date"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label">Gender</label>
                    <select
                        className="form-control"
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="photo">Photo</label>
                    <input
                        className="form-control"
                        id="photo"
                        type="file"
                        name="photo"
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label" htmlFor="profile">Profile Document</label>
                    <input
                        className="form-control"
                        id="profile"
                        type="file"
                        name="profile_upload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                    />
                </div>
              </div>
          )}
      </Modal>
    </Applayout>
  );
}

export default Beneficiaries;
